export default __webpack_public_path__ + "static/media/turtle.a0c9638f.png";